import { render, staticRenderFns } from "./dettaglioProduzione.vue?vue&type=template&id=1b109b09"
import script from "./dettaglioProduzione.vue?vue&type=script&lang=js"
export * from "./dettaglioProduzione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports